// extracted by mini-css-extract-plugin
export default {"container":"CookieBanner_container__uHrLu","title":"CookieBanner_title__FtMuK","subtitle":"CookieBanner_subtitle__frq-4","button":"CookieBanner_button__8oHSE"};